import React from "react";
import PropTypes from "prop-types";
import { Table } from "antd";
import Workbook from "react-excel-workbook";
import exportIcon from "../../../../../../assets/icons/export.svg";
import { StyleLessButton } from "../../../../../../CommonComponents/commonStyles";
import { IconPadding, DataExportPrint, WorkBookPrintWrap } from "./style";
import {
  milliToDate,
  getColumnLength,
  recordError,
} from "../../../../../../utils/commonUtil";
import PrintButton from "../../../../../../CommonComponents/PrintButton/PrintButton";
import { addressFormat } from "../../utils";
import PrintTableNew from "../../../../../../CommonComponents/PrintTable/PrintTable";
import { exportExcelTableData } from "../../../../../../services/apiServices";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
export const exportAnalytics = (props) => {
  try {
    props.analyticsHandler &&
      props.analyticsHandler(
        "export",
        "",
        `Export - ${props.printProps[props.activeTab - 1].title}`
      );
  } catch (error) {
    recordError(error);
  }
};

export const printAnalytics = (props) => {
  props.analyticsHandler &&
    props.analyticsHandler(
      "print",
      "",
      `Print - ${props.printProps[props.activeTab - 1].title}`
    );
};
export const exportCharities = (props) => {
  exportAnalytics(props);
  const { activeTab, recentGrants, savedCharities} = props;
  let userId = getPrimaryAccount().userId;
  let filename;
  let params;
  let url;
  if (activeTab === "1"){
    filename = 'Charities recently supported.xlsx';
    params = recentGrants;
    url = `/donor-portal/api/grant/${userId}/exportGrantedCharity`;
  } else {
    filename = 'Your saved charities.xlsx';
    params = savedCharities;
    url = `/donor-portal/api/granteeOrg/${userId}/exportCharityByAccountId`;
  }
  return exportExcelTableData(url, params, filename)
}
 
export default function WorkBookPrintGrant(props) {
  // remove the last column
  const recentGrantsCols = props.printProps[0].columnConfig;
  recentGrantsCols.pop();
  const savedCharitiesCols = props.printProps[1].columnConfig;
  savedCharitiesCols.pop();
  const { showGrantHistory, showPendingCharity, workbookId='' } = props;

  return (
    <WorkBookPrintWrap>
      <div className="wrapper" data-test='on-click'>
        {props.activeTab === "1" && (
          <StyleLessButton
            id={`btnExport${props.activeTab}`}
            onClick={() => exportCharities(props)}
          >
            <IconPadding primary={true}>
              <img src={exportIcon} alt="print-sheet1" />
              <DataExportPrint>EXPORT</DataExportPrint>
            </IconPadding>
          </StyleLessButton>
        )}
        {props.activeTab === "2" && (
          <StyleLessButton
            id={`btnExport${props.activeTab}`}
            onClick={() => exportCharities(props)}
          >
            <IconPadding primary={true}>
              <img src={exportIcon} alt="print-sheet2" />
              <DataExportPrint>EXPORT</DataExportPrint>
            </IconPadding>
          </StyleLessButton>
        )}
        <PrintButton
          id={`${workbookId}btnPrint`}
          className="ml2"
          printClick={() => printAnalytics(props)}
        >
          {!showGrantHistory &&
            !showPendingCharity &&
            props.activeTab === "1" && (
              <PrintTableNew
                dataSource={props.recentGrants}
                columns={recentGrantsCols}
                pagination={false}
                titleFn={true}
                hasIcons={true}
                width={getColumnLength(recentGrantsCols.length)}
              />
            )}
          {!showGrantHistory &&
            !showPendingCharity &&
            props.activeTab === "2" && (
              <PrintTableNew
                dataSource={props.savedCharities}
                columns={savedCharitiesCols}
                pagination={false}
                titleFn={true}
                width={getColumnLength(savedCharitiesCols.length)}
              />
            )}
        </PrintButton>
      </div>
    </WorkBookPrintWrap>
  );
}

WorkBookPrintGrant.propTypes = {
  activeTab: PropTypes.string.isRequired,
  analyticsHandler: PropTypes.func,
  printProps: PropTypes.arrayOf(
    PropTypes.shape({
      columnConfig: PropTypes.array.isRequired,
      data: PropTypes.array,
      destComponent: PropTypes.string,
      key: PropTypes.number,
      mobComponent: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string.isRequired,
    })
  ),
  recentGrants: PropTypes.arrayOf(
    PropTypes.shape({
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      addressLine3: PropTypes.string,
      charityId: PropTypes.number,
      charityName: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string,
      ein: PropTypes.string,
      grantId: PropTypes.number,
      granteeOrgein: PropTypes.string,
      idx: PropTypes.any,
      interestArea: PropTypes.string,
      isPending: PropTypes.bool,
      isRecurring: PropTypes.bool,
      lastGrantDate: PropTypes.number,
      location: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
    })
  ).isRequired,
  savedCharities: PropTypes.arrayOf(
    PropTypes.shape({
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      addressLine3: PropTypes.string,
      charityId: PropTypes.number,
      charityName: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string,
      cypherText: PropTypes.any,
      ein: PropTypes.string,
      einCi: PropTypes.any,
      granteeOrgAliasId: PropTypes.number,
      granteeOrgs: PropTypes.any,
      interestArea: PropTypes.any,
      isExisting: PropTypes.bool,
      isPending: PropTypes.bool,
      location: PropTypes.string,
      purpose: PropTypes.any,
      savedCharitieList: PropTypes.any,
      state: PropTypes.string,
      success: PropTypes.any,
      zip: PropTypes.string,
    })
  ).isRequired,
  showGrantHistory: PropTypes.bool,
  showPendingCharity: PropTypes.bool,
};
